
function toggleFold(index) {
	let $fold = $w('#fold' + index);
	let $arrowDown = $w('#arrowDown' + index);
	let $arrowRight = $w('#arrowRight' + index);
	// toggle the fold at the index
	if ($fold.collapsed) {
		$fold.expand();
		$arrowDown.show();
		$arrowRight.hide();
	}
	else {
		$fold.collapse();
		$arrowDown.hide();
		$arrowRight.show();
	}
}

export function headerBox1_onClick(event) {
	toggleFold(1);
}

export function headerBox2_onClick(event) {
	toggleFold(2);
}

export function headerBox3_onClick(event) {
	toggleFold(3);
}

export function headerBox4_onClick(event) {
	toggleFold(4);
}

export function headerBox5_onClick(event) {
	toggleFold(5);
}

export function headerBox6_onClick(event) {
	toggleFold(6);
}
